// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.pagination-container[data-v-72233bcd] {\r\n  background: #fff;\r\n  margin-top: 0;\r\n  padding: 16px;\r\n  text-align: right;\n}\n.pagination-container.hidden[data-v-72233bcd] {\r\n  display: none;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
